import { toNumberOrZero } from '~/utils/functions';
import { DadosIbsCbsCliente, ProcessoContexto } from '../protocols';
import { servicesIbsCbs } from '../services';
import { obterDadosIbsCbsCliente } from './obterDadosIbsCbsCliente';

export const processaIbsCbs = async (
  ctx: ProcessoContexto,
): Promise<DadosIbsCbsCliente | null> => {
  // 1) Ler/normalizar o COD_IBS_CBS do produto
  let codIbsCbs = ctx.qryProdutoCodIbsCbs || null;

  // 2) Se nulo/zero, usar o padrão
  if (ctx.qryProdutoCodIbsCbs === null || codIbsCbs === 0) {
    codIbsCbs = await servicesIbsCbs.retornaCodIbsCbsPadrao();
    const dadosDefault: DadosIbsCbsCliente = {
      cod_ibs_cbs: codIbsCbs,
      per_aliq_cbs: 0,
      per_red_cbs: 0,
      val_red_social: 0,
      per_aliq_ibs_est: 0,
      per_aliq_ibs_mun: 0,
      per_red_ibs: 0,
      cst_ibs_cbs: '',
      des_classif_trib_ibs_cbs: '',
    };
    return dadosDefault;
  }

  // 3) Se houver código válido, determinar cidade de consumo e alimentar dados (stub)
  if (codIbsCbs && codIbsCbs > 0) {
    let vCodCidadeConsumo = 0;

    switch (ctx.cbxLocalConsumoIndex) {
      case 0: // Origem
        vCodCidadeConsumo = toNumberOrZero(ctx.loja?.codCidade);
        break;
      case 1: // Destino (cidade do cliente selecionado)
        vCodCidadeConsumo = toNumberOrZero(ctx.cliMestreCodCidade);
        break;
      case 2: // Outros (cidade informada na aba de entrega)
        vCodCidadeConsumo = toNumberOrZero(ctx.cliCidadeCodCidade);
        break;
      default:
        vCodCidadeConsumo = toNumberOrZero(ctx.loja?.codCidade);
        break;
    }

    const dadosIbsCbsObtidos = await obterDadosIbsCbsCliente(
      codIbsCbs,
      vCodCidadeConsumo,
      ctx.loja.estado,
      ctx.empresa,
    );

    return dadosIbsCbsObtidos;
  }

  return null;
};
